import { MapUiTheme } from '../../common';

export const loadingSpinnerTheme = {
  defaultStyles: {
    display: 'inline-block',
    boxSizing: 'border-box',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderRadius: (theme: MapUiTheme) => theme.borderRadius.full,
  },
  xs: {
    width: (theme: MapUiTheme) => theme.spacing['3'],
    height: (theme: MapUiTheme) => theme.spacing['3'],
  },
  sm: {
    width: (theme: MapUiTheme) => theme.spacing['4'],
    height: (theme: MapUiTheme) => theme.spacing['4'],
  },
  md: {
    width: (theme: MapUiTheme) => theme.spacing['6'],
    height: (theme: MapUiTheme) => theme.spacing['6'],
  },
  lg: {
    width: (theme: MapUiTheme) => theme.spacing['7'],
    height: (theme: MapUiTheme) => theme.spacing['7'],
  },
  xl: {
    width: (theme: MapUiTheme) => theme.spacing['9'],
    height: (theme: MapUiTheme) => theme.spacing['9'],
  },
};
